import { useEffect, useState } from 'react';
import { subscribePrivateNotes } from '../../../../services/PrivateNotesService';
import { sortEntries } from '../../../../services/privateNotesModel';

/**
 * The student's Private file, live. OWNED BY THE PAGE (one listener), because
 * two surfaces render it: the rail, and the sheet that replaces the rail where
 * the rail is hidden or too narrow. Both read this one result, so the count on
 * the lesson bar's Private control and the entries can never disagree.
 */
const usePrivateNotes = (studentId) => {
	const [entries, setEntries] = useState([]);
	const [isLoading, setIsLoading] = useState(Boolean(studentId));
	const [error, setError] = useState('');

	useEffect(() => {
		if (!studentId) {
			setEntries([]);
			setIsLoading(false);
			return undefined;
		}
		setIsLoading(true);
		setError('');
		const unsubscribe = subscribePrivateNotes(
			studentId,
			(rows) => {
				setEntries(sortEntries(rows));
				setIsLoading(false);
			},
			(err) => {
				console.error('Error loading the private file:', err);
				setError(err?.message || String(err));
				setIsLoading(false);
			}
		);
		return unsubscribe;
	}, [studentId]);

	return { entries, isLoading, error };
};

export default usePrivateNotes;
